import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import ExperienceSelect from './ExperienceSelect'
import { utcRsvpToLocal24h } from '../../utils/rsvpDateTime'

const MINUTES_OPTIONS = ['00', '15', '30', '45']

const format24hToDisplay = (time24) => {
  if (!time24 || !/^\d{2}:\d{2}$/.test(time24)) return ''
  const parsed = moment(time24, 'HH:mm', true)
  return parsed.isValid() ? parsed.format('hh:mm A') : ''
}

const formatDisplayTo24h = (displayTime) => {
  if (!displayTime) return ''
  const parsed = moment(displayTime, 'hh:mm A', true)
  return parsed.isValid() ? parsed.format('HH:mm') : ''
}

const buildTimeOptions = () => {
  const hours = Array.from({ length: 12 }, (_, i) => i)
  const options = []

  const formatTime = (hour, minute, period) => {
    const formattedHour = hour === 12 ? 12 : hour % 12 || 12
    return `${formattedHour.toString().padStart(2, '0')}:${minute} ${period}`
  }

  ;['AM', 'PM'].forEach((period) => {
    hours.forEach((hour) => {
      MINUTES_OPTIONS.forEach((minute) => {
        options.push({
          value: formatTime(hour, minute, period),
          label: formatTime(hour, minute, period),
        })
      })
    })
  })

  return options
}

const RsvpTimePicker = ({
  value,
  onChange,
  utcDate,
  utcTime,
  isInvalid,
  onBlur,
  disabled = false,
}) => {
  const timeOptions = useMemo(() => buildTimeOptions(), [])

  const local24h = useMemo(() => {
    if (value) return value
    return utcRsvpToLocal24h(utcDate, utcTime)
  }, [value, utcDate, utcTime])

  const displayValue = format24hToDisplay(local24h)

  return (
    <ExperienceSelect
      options={timeOptions}
      value={displayValue}
      placeholder='Select time'
      isSearchable
      disabled={disabled}
      isInvalid={!!isInvalid}
      onChange={(event) => {
        onChange(formatDisplayTo24h(event.target.value))
      }}
      onBlur={onBlur}
    />
  )
}

RsvpTimePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  utcDate: PropTypes.string,
  utcTime: PropTypes.string,
  isInvalid: PropTypes.bool,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
}

export default RsvpTimePicker
